module.exports = "<div class=\"spc resources\">\n  <div class=\"list-group\">\n    <a *ngFor=\"let item of list\" [routerLink]=\"item.location\" class=\"item list-group-item\">\n      <p class=\"heading\">{{item.name}}<i class=\"ion-link pull-right after c1-text\"></i></p>\n      <div class=\"text\"><p><em>{{item.description}}</em></p></div>\n    </a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list/list.component.html
// module id = ./src/app/shared/list/list.component.html
// module chunks = main